import { defineComponent as _defineComponent } from 'vue'
import {
    E_Theme,
    getCurrentTheme,
    saveTheme
} from '@/utils/theme';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ThemeSwitch',
  setup(__props) {

let themeValue = ref(getCurrentTheme())

function onThemeChange(value: E_Theme) {
    saveTheme(value)
    setTimeout(() => {
        location.reload()
    }, 0)
}


return { __sfc: true,themeValue, onThemeChange, E_Theme }
}

})